/**
 * Created by wangjianwen on 2017/10/17.
 */
export const subscribePlugin = function () {
    return store => {
        store.subscribe((mutation, state) => {
            //console.log('mutation', mutation, 'state', state)
        })
    }
}